import { ScatterplotLayer } from '@deck.gl/layers';
import { LayerProps, MapViewState } from '@deck.gl/core';
import { HouseholdGroup } from '../../types/global';

type ClickHandler = NonNullable<LayerProps['onClick']>;

export default function scatterplotLayer(LayerData: Array<HouseholdGroup>, showInfo: ClickHandler, viewState: MapViewState) {
  const zoom = viewState?.zoom ?? 8;
  const radiusScale = zoom < 10 ? 2 : 1;
  const lineWidthScale = zoom < 10 ? 3 : 1;

  const newLayer = new ScatterplotLayer({
    id: 'scatter-layer',
    data: LayerData,
    stroked: true,
    getPosition: (d: HouseholdGroup) => [d.coordinates.longitude, d.coordinates.latitude],
    getFillColor: [221, 28, 119],
    getLineColor: [133, 0, 64],
    getLineWidth: 0.25,
    lineWidthScale,
    lineWidthUnits: 'pixels',
    getRadius: 2,
    radiusScale,
    radiusUnits: 'pixels',
    onClick: (info, event) => showInfo(info, event),
    pickable: true,
  });
  return newLayer;
}
